import React from 'react';
// import sections
// import Hero from '../components/sections/Hero';
// import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeatureSplitGallery from '../components/sections/FeatureSplitGallery';
// import Testimonial from '../components/sections/Testimonial';

const Gallery = () => {

  return (
    <>
      <FeatureSplitGallery invertMobile topDivider imageFill className="illustration-section-02" />
      {/* <Hero className="illustration-section-01" />
      <FeaturesTiles />
      <FeaturesSplit invertMobile topDivider imageFill className="illustration-section-02" />
      <Testimonial topDivider />
      <Cta split /> */}
    </>
  );
}

export default Gallery;